var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"VueTables__primary-content"},[_vm._v("\n        "+_vm._s(_vm.trans(`reporting.status.${_vm.status}`))+"\n    ")]),_vm._v(" "),(_vm.completedDate)?_c('div',{staticClass:"VueTables__secondary-content"},[_vm._v("\n        "+_vm._s(_vm.completedDate)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }